import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { submitClaim, reportEvent } from '@api';
import {
  ErrorCode, RespCode, env,
  // ClaimType,
} from '@constants';
import { logError } from '@log';
import { clearSelectedItems } from '@store/slices/claimSlice';

export const useReview = () => {
  const [isConfirmed, setIsConfirmed] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const {
    files,
    type,
    orderName, selectedData, selectedPackageList, reviewData, comments,
  } = useSelector((state) => state.claim);
  // const {
  //   estimateRefundValue,
  //   hasEstimateRefund,
  //   resolution,
  // } = reviewData;
  const {
    reasonList, paymentMethod, behaviorData,
  } = useSelector((state) => state.policy);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // const estimateRefund = hasEstimateRefund ? `$${estimateRefundValue}` : 'To be determined';

  const handleChange = (event) => {
    setIsConfirmed(event.target.checked);
  };

  const onClickContinue = async () => {
    const url = env === 'prod' ? 'https://api.seel.com/gateway/tracking-service/api/tracking-event' : 'https://api-dev.seel.com/gateway/tracking-service/api/tracking-event';
    try {
      setIsLoading(true);
      const reportData = {
        ...behaviorData,
        submitTime: Date.now(),
      };
      const resp = await submitClaim(selectedData);
      setIsLoading(false);
      const { code, data, message } = resp;
      if (code !== RespCode.Success) {
        // 失败上报
        reportData.isSuccess = false;
        reportData.failureReason = message || code;
        reportEvent('Claim submission failed', { reportData, url });
        // eslint-disable-next-line max-len
        const errorMap = [ErrorCode.Expired, ErrorCode.Total, ErrorCode.Cancelled, ErrorCode.HasOldClaim, ErrorCode.CoverdItemEmpty];
        if (errorMap.includes(code)) {
          navigate('/17track/error', { state: { code } });
        } else {
          navigate('/17track/error', { state: { code: ErrorCode.Wrong } });
        }
        return;
      }

      // 成功上报
      reportData.isSuccess = true;
      reportEvent('Claim submission succeed', { reportData, url });

      dispatch(clearSelectedItems());
      navigate(`/17track/feedback?claimId=${data.claimId}`);
    } catch (error) {
      logError(error);
    }
  };

  return {
    files,
    orderName,
    type,
    reviewData: { ...reviewData, ...paymentMethod },
    reasonList,
    selectedPackageList,
    isConfirmed,
    isLoading,
    comments,
    onClickContinue,
    handleChange,
  };
};
